// @flow

import type { DrBillCoreLib } from '@bil0-dr-bill/dr-bill-core'

const CACHE: { core: DrBillCoreLib } = { core: {} }

const load: () => Promise<void> = () =>
  import('@bil0-dr-bill/dr-bill-core')
    .then((core: DrBillCoreLib) => {
      core.onLoadHook()

      Object.entries(core).forEach(([fnName, fn]) => {
        if (!fnName.startsWith('__')) {
          CACHE.core[fnName] = fn
        }
      })

      if (process.env.NODE_ENV === 'development') {
        window.Core = CACHE.core
      }
    })
    .catch((e) => {
      console.log('Failed to load DrBillCore')
      console.log(e)
    })

exports.load = load
exports.core = CACHE.core
